import { pgEnum } from 'drizzle-orm/pg-core';

// Enum for billing run merge strategy
// Controls how invoices are merged during billing runs
// Shared by billing_run table and customer table (as override)
// Note: USE_CUSTOMER_PREFERENCE is only valid for billing_run.mergeStrategy, not for customer.invoiceMergeStrategy
export const billing_run_merge_strategy = pgEnum('billing_run_merge_strategy', [
  'BY_CUSTOMER',
  'BY_JOB_SITE',
  'NO_MERGE',
  'USE_CUSTOMER_PREFERENCE',
]);

// Enum for billing run invoice source filter
export const billing_run_invoice_source_filter = pgEnum('billing_run_invoice_source_filter', [
  'ALL',
  'SUBSCRIPTION_ONLY',
]);

